const noUser = () => {
    window.location.href = '/login'
};

export default noUser;